import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ConfirmDialog {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  isDanger?: boolean;
  resolve: (value: boolean) => void;
}

@Injectable({
  providedIn: 'root'
})
export class ConfirmService {
  private dialogSubject = new BehaviorSubject<ConfirmDialog | null>(null);
  dialog$ = this.dialogSubject.asObservable();

  confirm(title: string, message: string, confirmText = 'Conferma', cancelText = 'Annulla', isDanger = false): Promise<boolean> {
    return new Promise((resolve) => {
      this.dialogSubject.next({
        title,
        message,
        confirmText,
        cancelText,
        isDanger,
        resolve
      });
    });
  }

  handleResult(result: boolean) {
    const dialog = this.dialogSubject.value;
    if (dialog) {
      dialog.resolve(result);
      this.dialogSubject.next(null);
    }
  }
}
